module.exports = __webpack_public_path__ + "fonts/myriadpro-semibold.86bb1295.otf";